export default {
  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  "cat.shoes.desc": "Sneakersy i buty na co dzień",
  "cat.hoodies.desc": "Przytulne bluzy i swetry",
  "cat.tshirts.desc": "Codzienne koszulki",
  "cat.jackets.desc": "Warstwy na chłodne dni",
  "cat.pants.desc": "Joggery, spodnie i szorty",
  "cat.headwear.desc": "Czapki, beanie i więcej",
  "cat.sets.desc": "Dwuczęściowe zestawy",
  "cat.underwear.desc": "Wygodna bielizna na co dzień",
  "cat.jersey.desc": "Meczowe koszulki sportowe",
  "cat.accessories.desc": "Drobne akcesoria i dodatki",
  "cat.bags.desc": "Torby i plecaki",
  "cat.belts.desc": "Paski",
  "cat.perfumes.desc": "Świeże zapachy",
  "cat.other.desc": "Wszystko inne, co kochają fani",

  "home.heroBadge": "Niezależne źródło merchu dla fanów",
  "home.heroTitle": "US Fans Spreadsheet — wszystkie kategorie merchu dla fanów w jednym miejscu",
  "home.heroSubtitle": "Przeglądaj buty, koszulki sportowe, bluzy i więcej dzięki przejrzystemu i uporządkowanemu źródłu, które pomaga szybciej znaleźć ulubiony sprzęt.",
  "home.heroCta1": "usfans spreadsheet",
  "home.heroCta2": "kup teraz",
  "home.heroTrust": "Szybkie linki do kategorii • Wyselekcjonowany sprzęt • Regularnie aktualizowane",

  "home.dropdownTitle": "Przeglądaj kategorie merchu dla fanów",
  "home.dropdownSubtitle": "Wybierz kategorię z menu, aby przejść bezpośrednio do tej kolekcji w naszym głównym sklepie.",

  "home.categoriesTitle": "Odkryj każdą kategorię",
  "home.categoriesSubtitle": "Kliknij dowolną kategorię, aby otworzyć jej dedykowaną stronę kolekcji w głównym sklepie.",

  "home.aboutTitle": "Czym jest US Fans Spreadsheet?",
  "home.aboutP1": "US Fans Spreadsheet to uporządkowane i łatwe w nawigacji źródło, które gromadzi merch dla fanów w jasno opisanych kategoriach. Zamiast przekopywać rozproszone strony, możesz przejść prosto do sprzętu, którego chcesz — od butów i koszulek sportowych po bluzy, kurtki, torby i akcesoria.",
  "home.aboutP2": "Każda kategoria prowadzi bezpośrednio do wyselekcjonowanej kolekcji w naszym głównym sklepie, dzięki czemu tracisz mniej czasu na szukanie, a więcej na znajdowanie rzeczy pasujących do Twojego stylu. Niezależnie od tego, czy szukasz nowej pary sneakersów, czy pełnego pasującego zestawu, wszystko jest o jeden klik.",
  "home.aboutB1": "Merch dla fanów uporządkowany w jednym czystym miejscu",
  "home.aboutB2": "Bezpośrednie linki do każdej głównej kategorii",
  "home.aboutB3": "Wskazówki przyjazne dla początkujących",
  "home.aboutB4": "Kolekcje regularnie aktualizowane",

  "home.guideTitle": "Polecany przewodnik",
  "home.guideSubtitle": "Dowiedz się, jak działa to źródło i jak wybrać odpowiedni sprzęt dla fanów.",
  "home.guideCategory": "Poradnik zakupowy",
  "home.guideCardTitle": "Czym jest US Fans Spreadsheet? Kompletny przewodnik",
  "home.guideCardDesc": "Dowiedz się, jak działa to źródło, jakie kategorie są dostępne i jak wybrać odpowiedni merch dla fanów.",
  "home.guideRead": "Przeczytaj przewodnik",
  "home.guideTime": "6 min czytania",
};